import DragAndDrop2List from './DragAndDrop2List.vue';
import DragAndDrop2 from './DragAndDrop2.vue';

export default {
  DragAndDrop2List,
  DragAndDrop2,
};
